var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "85.355%",
    y1: "14.645%",
    x2: "14.645%",
    y2: "85.355%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC5B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.966%",
    y1: "0%",
    x2: "49.966%",
    y2: "100%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A524B3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2D55",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#a)",
    cx: 200,
    cy: 200,
    r: 200
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M125.7 0v150h125z",
    transform: "translate(16 130)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.7 280h125V130z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 320c11.4 15.1 24.9 28.6 40 40h240c15.1-11.4 28.6-24.9 40-40H40z",
    fill: "#FC9965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 360c33.4 25.1 75 40 120 40s86.6-14.9 120-40H80z",
    fill: "#FF2D55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M252.3 0v110H344z",
    transform: "translate(16 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.3 280H16.7c6.2 14.3 14.1 27.7 23.3 40h228.4v-40h-.1z",
    fill: "#FFBC5B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M176.7 320h91.6V210z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFC95B",
    cx: 268.3,
    cy: 130,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFC95B",
    cx: 141.7,
    cy: 75,
    r: 25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana);
export default __webpack_public_path__ + "static/media/MANA.b51c6558000a8317084cfedb7a11cd9b.svg";
export { ForwardRef as ReactComponent };